import { Text, Icon } from 'components/common'
import { forwardRef } from 'react'
import CommentsCountStyle from './style'

const CommentsCount = forwardRef((props,ref) => {
	return (
		<CommentsCountStyle onClick={props.onClick} ref={ref} className={`comments flexBox alignMiddle ${props.defaultMouse ? '' : 'cursorPointer'}`}>
			<Icon className='op-message darkGrey' />
			<Text tag={'p'} className='h8 PopReg darkGrey' text={props.commentsCount} />
		</CommentsCountStyle>
	)
})

export default CommentsCount
